/** Scrolls only the nearest scrolling ancestor so `element`'s top meets its top, as far as its scroll range allows. */
export const scrollToTop = (element: HTMLElement): void => {
  for (let node = element.parentElement; node; node = node.parentElement) {
    if (/(auto|scroll)/.test(getComputedStyle(node).overflowY)) {
      node.scrollTop +=
        element.getBoundingClientRect().top -
        node.getBoundingClientRect().top -
        node.clientTop;
      return;
    }
  }
};
